export default {
  back: {
    id: 'outlet_detail_back',
    defaultMessage: 'Back',
  },
}
